/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
export const __DEV__ = process.env.NODE_ENV !== 'production';
